import React from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import CustomButton from '../../../components/customButton';

const DeleteCampaignModal = ({ isOpen, cancelCallback, confirmCallback, isLoading }) => {
  return (
    <Modal size="lg" id="delete-campaign-modal" isOpen={isOpen} fade={false} centered>
      <ModalHeader>
        Delete Campaign
        <p className="subtitle">Are you sure you want to delete this Campaign?</p>
      </ModalHeader>
      <ModalBody>
        <p>This action cannot be undone. All data associated with this campaign will be permanently deleted.</p>
      </ModalBody>
      <ModalFooter>
        <CustomButton title="Cancel" classes="btn btn-secondary" handleClick={() => cancelCallback(false)} />
        <CustomButton
          title="Delete Campaign"
          classes="btn btn-danger"
          handleClick={() => confirmCallback()}
          loading={isLoading}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteCampaignModal;
